<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NIeojQ/tc-custom/9781948239141.jpg?1737164547430" alt="This image is the cover for the book Ted Bundy's Murderous Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ted Bundy's Murderous Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>The true crime author of <i>The Bundy Murders</i> provides an in-depth look at the notorious serial killer and his victims through revealing new interviews.</b><br/>  <br/> Though the true number of his victims may never be known, Ted Bundy took the lives of at least thirty young women and girls across the United States. He often targeted college students, leaving a trail of devastation from the University of Washington in the Pacific Northwest all the way to Florida State University.<br/>  <br/> In <i>Ted Bundy’s Murderous Mysteries</i>, true crime author and Bundy expert Kevin M. Sullivan sheds new light on the man, his victims, and this voluminous case. Here are candid and revealing interviews with friends and family of the victims, individuals close to Bundy himself—and a potential victim who barely escaped his clutches. Within these pages, Sullivan exposes many heretofore passed-over facts about Bundy and reveals previously hidden aspects of the lives of some of his victims.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Sullivan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?64bb48a4